import { IonContent } from '@ionic/react';
import React from 'react';
import { useFormContext } from 'react-hook-form';

import { amplitudeModule } from '@/modules/amplitude';
import { OnboardingNavigation } from '@/pages/Onboarding/components/Navigation';
import {
  OptionItemSpriteLarge,
  OptionItemSpriteLargeList,
} from '@/pages/Onboarding/components/OptionItemSpriteLarge';
import { OnboardingPage } from '@/pages/Onboarding/components/Page';
import { useOnboarding } from '@/pages/Onboarding/context';
import { OwnAiTitle } from '@/pages/Onboarding/Layouts/OwnAI/components/Title';
import { PARTY_BEHAVIOR_COMPATIBILITY_OPTIONS } from '@/pages/Onboarding/options/PartyBehaviorCompatibility/PARTY_BEHAVIOR_COMPATIBILITY_OPTIONS';
import { OnbOptionType } from '@/pages/Onboarding/types';
import { nextStepTimeout } from '@/pages/Onboarding/utils/nextStepTimeout';
import { userService } from '@/services/user';
import { canLogEvents } from '@/utils/canLogEvents';

import { LayoutDataType } from '../../types';

export const ScreenPartyBehavior: React.FC = () => {
  React.useEffect(() => {
    if (canLogEvents()) {
      amplitudeModule.logEvent('onboarding_screen', {
        seen: 'PartyBehavior',
      });
    }
  }, []);

  const { wizard } = useOnboarding();

  const form = useFormContext<LayoutDataType>();

  const partyBehavior = form.watch('party_behavior');

  const handleChange = (
    option: OnbOptionType<LayoutDataType['party_behavior']>,
  ) => {
    form.setValue('party_behavior', option.id);
    userService.createOrUpdate({
      onboarding_data: {
        partyBehavior: option.title,
      },
    });
    nextStepTimeout(wizard.nextStep);
  };

  const getImageSrc = (optionId: string) => {
    return `/assets/own-ai-compatibility/party-behavior/${optionId}.png`;
  };

  return (
    <OnboardingPage background={'dark-solid'}>
      <OnboardingNavigation />

      <IonContent>
        <OwnAiTitle>At a party, do you...?</OwnAiTitle>
        <OptionItemSpriteLargeList>
          {PARTY_BEHAVIOR_COMPATIBILITY_OPTIONS.map((option) => (
            <OptionItemSpriteLarge
              key={option.id}
              spriteSrc={getImageSrc(option.id)}
              alt={option.title}
              title={option.title}
              isSelected={partyBehavior === option.id}
              onClick={() => handleChange(option)}
              TEST_ID={`party-behavior-${option.id}`}
              show={true}
              animate={true}
              disableGrayscale={true}
            />
          ))}
        </OptionItemSpriteLargeList>
      </IonContent>
    </OnboardingPage>
  );
};
